import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '../apollo/hooks/customApolloHooks/customApolloHooks';
export type Maybe<T> = T;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {"context":{"client-name":"franchise"}} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type WordPressFranchiseLocationsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type WordPressFranchiseLocationsDataQuery = {
  __typename?: 'RootQuery',
  locationsql?: {
    __typename?: 'RootQueryToLocationqlConnection',
    nodes: Array<{
      __typename?: 'Locationql',
      locationInformation?: {
        __typename?: 'LocationInformation',
        asFranchiseGetDirectionsLink?: string,
        asFranchiseCity?: string,
        asFranchiseCountry?: string,
        asFranchisePostalCode?: string,
        asFranchiseState?: Array<string>,
        asFranchiseId?: Array<string>,
        asFranchiseStreetAddress?: string,
        asFranchiseEmail?: string,
        asFranchisePhone?: string,
        asFranchiseName?: string,
        asFranchiseWeeklyHours?: Array<{
          __typename?: 'LocationInformationAsFranchiseWeeklyHours',
          asFranchiseCh?: string,
          asFranchiseOh?: string,
          asFranchiseWhDay?: Array<string>
        }>
      }
    }>
  },
  reviewsql?: {
    __typename?: 'RootQueryToReviewqlConnection',
    nodes: Array<{
      __typename?: 'Reviewql',
      content?: string,
      reviewDetails?: {
        __typename?: 'ReviewDetails',
        reviewerName?: string
      }
    }>
  },
  menuItem?: {
    __typename?: 'MenuItem',
    id: string,
    databaseId: number,
    label?: string,
    url?: string,
    childItems?: {
      __typename?: 'MenuItemToMenuItemConnection',
      edges: Array<{
        __typename?: 'MenuItemToMenuItemConnectionEdge',
        node: {
          __typename?: 'MenuItem',
          id: string,
          databaseId: number,
          label?: string,
          url?: string
        }
      }>
    }
  }
};


export const WordPressFranchiseLocationsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WordPressFranchiseLocationsData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsql"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asFranchiseGetDirectionsLink"}},{"kind":"Field","name":{"kind":"Name","value":"asFranchiseCity"}},{"kind":"Field","name":{"kind":"Name","value":"asFranchiseCountry"}},{"kind":"Field","name":{"kind":"Name","value":"asFranchisePostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"asFranchiseState"}},{"kind":"Field","name":{"kind":"Name","value":"asFranchiseId"}},{"kind":"Field","name":{"kind":"Name","value":"asFranchiseStreetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"asFranchiseEmail"}},{"kind":"Field","name":{"kind":"Name","value":"asFranchisePhone"}},{"kind":"Field","name":{"kind":"Name","value":"asFranchiseName"}},{"kind":"Field","name":{"kind":"Name","value":"asFranchiseWeeklyHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asFranchiseCh"}},{"kind":"Field","name":{"kind":"Name","value":"asFranchiseOh"}},{"kind":"Field","name":{"kind":"Name","value":"asFranchiseWhDay"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewsql"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"reviewDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewerName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"StringValue","value":"295","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"idType"},"value":{"kind":"EnumValue","value":"DATABASE_ID"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"childItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"databaseId"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useWordPressFranchiseLocationsDataQuery__
 *
 * To run a query within a React component, call `useWordPressFranchiseLocationsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useWordPressFranchiseLocationsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWordPressFranchiseLocationsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useWordPressFranchiseLocationsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WordPressFranchiseLocationsDataQuery, WordPressFranchiseLocationsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WordPressFranchiseLocationsDataQuery, WordPressFranchiseLocationsDataQueryVariables>(WordPressFranchiseLocationsDataDocument, options);
      }
export function useWordPressFranchiseLocationsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WordPressFranchiseLocationsDataQuery, WordPressFranchiseLocationsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WordPressFranchiseLocationsDataQuery, WordPressFranchiseLocationsDataQueryVariables>(WordPressFranchiseLocationsDataDocument, options);
        }
export function useWordPressFranchiseLocationsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WordPressFranchiseLocationsDataQuery, WordPressFranchiseLocationsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WordPressFranchiseLocationsDataQuery, WordPressFranchiseLocationsDataQueryVariables>(WordPressFranchiseLocationsDataDocument, options);
        }
export type WordPressFranchiseLocationsDataQueryHookResult = ReturnType<typeof useWordPressFranchiseLocationsDataQuery>;
export type WordPressFranchiseLocationsDataLazyQueryHookResult = ReturnType<typeof useWordPressFranchiseLocationsDataLazyQuery>;
export type WordPressFranchiseLocationsDataSuspenseQueryHookResult = ReturnType<typeof useWordPressFranchiseLocationsDataSuspenseQuery>;
export type WordPressFranchiseLocationsDataQueryResult = Apollo.QueryResult<WordPressFranchiseLocationsDataQuery, WordPressFranchiseLocationsDataQueryVariables>;